import React from "react";
import { Star } from "lucide-react";
import { useCatalog } from "../../contexts/CatalogContext";

export default function TestimonialsSection() {
  const { TESTIMONIALS } = useCatalog();

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-testid="testimonials">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <span className="text-xs font-semibold text-[#FF6B2B] uppercase tracking-widest">What customers say</span>
        <h2 className="font-display font-bold text-3xl sm:text-4xl text-slate-900 mt-2">Real reviews from real homes</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {TESTIMONIALS.map((t) => (
          <TestimonialCard key={`${t.name}-${t.service}`} t={t} />
        ))}
      </div>
    </section>
  );
}

const TestimonialCard = ({ t }) => (
  <div
    data-testid={`testimonial-${t.name.toLowerCase().replace(/\s+/g, '-')}`}
    className="bg-white rounded-2xl p-6 border border-slate-200 card-shadow"
  >
    <div className="flex gap-0.5 mb-3">
      {Array.from({ length: 5 }).map((_, idx) => (
        <Star
          key={`star-${t.name}-${idx}`}
          className={`w-4 h-4 ${idx < t.rating ? "text-[#FF6B2B] fill-[#FF6B2B]" : "text-slate-200"}`}
        />
      ))}
    </div>
    <p className="text-sm text-slate-700 leading-relaxed">"{t.text}"</p>
    <div className="mt-5 pt-4 border-t border-slate-100">
      <div className="font-semibold text-sm text-slate-900">{t.name}</div>
      <div className="text-xs text-slate-500 mt-0.5">{t.location} • {t.service}</div>
    </div>
  </div>
);
